import React from 'react';

import ErrorLayout from 'components/ErrorLayout';
import Loader from 'components/Loader';
import Table from 'components/Table';
import TableCell from 'components/TableCell';
import TableHead from 'components/TableHead';
import TableRow from 'components/TableRow';
import UploadVideoTableBody from '../UploadVideoTableBody';

export default function UploadedVideosTable({
  uploadedVideos,
  isLoading,
  error,
}) {
  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return (
      <ErrorLayout
        title="Failed to load videos"
        message={
          error?.data?.message || 'Something went wrong! Try again later'
        }
      />
    );
  } else if (uploadedVideos?.length > 0) {
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Link</TableCell>
            <TableCell>Raw Asset ID</TableCell>
          </TableRow>
        </TableHead>
        <UploadVideoTableBody uploadedVideos={uploadedVideos} />
      </Table>
    );
  } else {
    return (
      <ErrorLayout
        title="No data available"
        message="Try searching another video"
      />
    );
  }
}
